import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeDataMethod } from "../core/base-api/methods-maker";
import { normalizeRequestorTransformer } from "../core/requestor/transformer-utils";

var perserveData = function perserveData(original) {
  return function () {
    return JSON.stringify(original);
  };
};

export var FormsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(FormsApi, _BaseApi);

  var _super = _createSuper(FormsApi);

  function FormsApi(config) {
    var _config$caseOptions, _config$caseOptions$c, _config$caseOptions2;

    _classCallCheck(this, FormsApi);

    return _super.call(this, _objectSpread(_objectSpread({}, config), {}, {
      caseOptions: (_config$caseOptions = config.caseOptions) !== null && _config$caseOptions !== void 0 ? _config$caseOptions : {
        caseMiddleware: (_config$caseOptions$c = (_config$caseOptions2 = config.caseOptions) === null || _config$caseOptions2 === void 0 ? void 0 : _config$caseOptions2.caseMiddleware) !== null && _config$caseOptions$c !== void 0 ? _config$caseOptions$c : {
          requestInterceptor: function requestInterceptor(config) {
            if (!config.url.startsWith('/forms/')) return config;
            if (!('answers' in config.data)) return config;
            var perserveDataTransformer = perserveData(config.data);
            var transformRequest = normalizeRequestorTransformer(config.transformRequest);
            config.transformRequest = [].concat(_toConsumableArray(transformRequest), [perserveDataTransformer]);
            return config;
          }
        }
      }
    }));
  }

  return FormsApi;
}(BaseApi);
/**
 * process form data from pages
 */

FormsApi.prototype.post = makeDataMethod({
  method: 'post',
  path: Request.Forms.Paths.Post,
  needAuth: false
});